import { useState } from 'react'
import { jobsApi } from '../api/client'
import type { PreviewRequest, PreviewResponse } from '../types'

/**
 * Hook that talks to the preview endpoint (``POST /api/v1/jobs/preview``).
 *
 * The endpoint is read-only (it plans WITHOUT generating), so calling it on
 * every "Generar PDF" click is safe: no job is created until the user
 * confirms in the modal.
 */
export function usePreview() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [preview, setPreview] = useState<PreviewResponse | null>(null)

  /** Request the plan for ``request``; returns it, or null on failure. */
  const fetchPreview = async (request: PreviewRequest): Promise<PreviewResponse | null> => {
    setLoading(true)
    setError(null)
    try {
      const data = await jobsApi.preview(request)
      setPreview(data)
      return data
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'No se pudo calcular el resumen previo'
      )
      setPreview(null)
      return null
    } finally {
      setLoading(false)
    }
  }

  /** Reset the state (modal closed / new preview requested). */
  const resetPreview = (): void => {
    setPreview(null)
    setError(null)
    setLoading(false)
  }

  return { preview, loading, error, fetchPreview, resetPreview }
}
